module.exports = __webpack_public_path__ + "media/images/planning_a_trip_to_japan/ko/5/2-9b6d4784d156aa765196c733e5ce0bba.jpg";